// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import { BootstrapVue } from 'bootstrap-vue';

import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import '@fortawesome/fontawesome-free/css/all.css';



Vue.config.productionTip = false;
Vue.use(BootstrapVue);


// Tell Vue to treat <model-viewer> as a custom element
Vue.config.ignoredElements = [/model-viewer/];

new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
